// extracted by mini-css-extract-plugin
export default {"btn":"OptionRow-module__btn--XQFMP","value":"OptionRow-module__value--EF7Zz","arrow":"OptionRow-module__arrow--Tj3uJ"};